import React, { useState } from "react";
import { usePartsData } from "../../hooks/usePartsData";
import { Box, Column, Columns, Pagination, Table } from "@allxsmith/bestax-bulma";
import {useDispatch, useSelector} from "react-redux";
import {
  getDataFresh,
  getPartsData,
  getVehicleMakeData,
  getVehicleModelData,
  getVehicleTypesData
} from "../../state/selectors";
import PartHistoryRow from "./PartHistoryRow";
import useSelect from "../../hooks/useSelect";
import {createSetPartsDataAction, createSetWorkDataAction} from "../../actions/dataActions";
import {useVehicleTypeData} from "../../hooks/useVehicleTypeData";
import FilterBlankHeading from "../Invoicing/FilterBlankHeading";
import FilterHeading from "../Invoicing/FilterHeading";
import {useVehicleMakeData} from "../../hooks/useVehicleMakeData";
import {useVehicleModelData} from "../../hooks/useVehicleModelData";
import SearchBar from "../Utils/SearchBar";
import Nav from "../Nav/Nav";
import LoadingSpinner from "../Utils/Spinner";
import PaginationWrapper from "../Utils/PaginationWrapper";

function PartHistory(props) {
  const [searchText, setSearchText] = useState("");
  const [search, setSearch] = useState(null);
  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(1);
  const dataFresh = useSelector(getDataFresh);
  const dispatch = useDispatch()

  const vehicle_types_loaded = useVehicleTypeData({});
  const makes_loaded = useVehicleMakeData({}, dataFresh);
  const models_loaded = useVehicleModelData({}, dataFresh);
  const vehicle_types = useSelector(getVehicleTypesData);
  const makes = useSelector(getVehicleMakeData);
  const models = useSelector(getVehicleModelData);

  const headings = [
    {
      label: "Registration",
      field: "job__vehicle",
      labelField: "job__vehicle__registration"
    },
    {
      label: "Make",
    },
    {
      label: "Model",
    },
    {
      label: "Type",
    },
    {
      label: "Part Name",
      blank: true,
      field: "name"
    },
    {
      label: "Part Number",
      blank: true,
      field: "part_number"
    },
    {
      label: "Cost",
      blank: true,
      field: "cost"
    },
    {
      label: "Date Ordered",
      field: "date_ordered",
      labelField: "date_ordered",
      date: true
    },
    {
      label: "Supplier",
      field: "supplier",
      labelField: "supplier__display_name"
    },
    {
      label: "Stock Volume",
    },
    {
      label: "Comments"
    }
  ];

  const [viewParam, viewInput] = useSelect({
    label: "View",
    options: [
      { name: "All", value: "all" },
      { name: "Hidden", value: "hidden" },
      { name: "Stock", value: 'lookup_stock'}
    ],
    initialValue: "all",
    testId: "part-view",
    callback: () => {
      setPage(1);
    }
  });

  let lookupHidden, partStockLookup;

  if (viewParam === "all") {
    lookupHidden = false;
  } else if (viewParam === 'hidden') {
    lookupHidden = true;
  } else if (viewParam === 'lookup_stock') {
    partStockLookup = true;
  }

  let params = {
    page,
    search,
    lookup_hidden: lookupHidden,
    part_lookup_stock: partStockLookup,
    view: "with_number"
  };

  for (let filter in filters) {
    if (filters[filter][0] && filters[filter][0][filter]) {
      params[filter] = filters[filter][0][filter];
    }
  }

  const complete = usePartsData(params, dataFresh);
  const data = useSelector(getPartsData);

  const updateValue = (index, newPart) => {
    let newResults = [...data.results]
    let currentData = { ...data, results: newResults };
    currentData.results[index] = newPart;
    dispatch(createSetPartsDataAction(currentData));
  };

  if (!complete || !vehicle_types_loaded || !models_loaded || !makes_loaded) {
    return (
        <div>
          <Nav/>
          <LoadingSpinner/>
        </div>
    )
  }

  document.title = "Part History";

  const clear = () => {
    setSearch("");
    setSearchText("");
  }
  const handleSearch = (e) => {
    setPage(1);
    setSearch(searchText)
  }
  // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
  return (
    <div>
      <Nav/>
      <br/>
      <br/>
      <Box>
        <Columns isMultiline>
          {viewInput}
          <Column>
            <label className="label">Part Search</label>
            <SearchBar
              handleSearch={handleSearch}
              setSearchText={setSearchText}
              clear={clear}
              searchText={searchText}
              searchButtonTestId={"search-button"}
              inputTestId={"part-search"}
            />
          </Column>
        </Columns>
      </Box>
      <Box>
        <Table>
          <thead>
            <tr>
              {headings.map(heading => {
                if (!heading.field) {
                  return <th key={heading.label}>{heading.label}</th>;
                }
                if (heading.blank) {
                  return (
                    <FilterBlankHeading
                      key={heading.label}
                      heading={heading}
                      setFilters={f => {
                        setPage(1);
                        setFilters(f);
                      }}
                      filters={filters}
                    />
                  );
                }
                return (
                  <FilterHeading
                    key={heading.label}
                    heading={heading}
                    setFilters={f => {
                      setPage(1);
                      setFilters(f);
                    }}
                    filters={filters}
                    options={data.filter_list[heading.field]}
                  />
                );
              })}
            </tr>
          </thead>
          <tbody>
            {data.results.map((part, index) => (
              <PartHistoryRow
                key={part.id}
                part={part}
                endpoint={props.endpoint}
                updateValue={newPart => updateValue(index, newPart)}
                vehicleTypes={vehicle_types.results}
                makes={makes}
                models={models}
              />
            ))}
          </tbody>
        </Table>
        <PaginationWrapper
          setPage={setPage}
          page={page}
          dataCount={Math.ceil(data.count / 25)}
        ></PaginationWrapper>
      </Box>
    </div>
  );
}

export default PartHistory;
